import { twMerge } from "tailwind-merge";

import { cn } from "@/utils/cn";

export function LoadingEllipsis({
  className,
  dark,
}: {
  className?: string;
  dark?: boolean;
}) {
  const dotClassName = cn(
    "h-[6px] w-[6px] animate-ellipsis rounded-full",
    dark === true ? "bg-gray-900" : "bg-primary"
  );

  return (
    <div
      className={twMerge(
        "flex items-center justify-center space-x-1",
        className
      )}
    >
      <div className={dotClassName}></div>
      <div className={dotClassName} style={{ animationDelay: "0.2s" }}></div>
      <div className={dotClassName} style={{ animationDelay: "0.4s" }}></div>
    </div>
  );
}
